<template>
  <el-container class="entertainmentPlace">
    <!-- 单位信息 -->
    <el-card class="tree-card" :body-style="treeCard">
      <div class="tree-box">
        <el-card
          :class="{ hoverCard: ListIndex === index }"
          v-for="(item, index) in list"
          :key="index"
          shadow="always"
          @click="ListClick(item, index)"
        >
          <div class="mycard">
            <span>{{ item.name }}</span>
          </div>
        </el-card>
      </div>
    </el-card>
    <component ref="componentRef" :is="componentIs"></component>
  </el-container>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
// import { ElMessageBox, ElMessage } from "element-plus";
import entertainmentPlaceJB from "@/views/industryControl/entertainmentPlace/components/entertainmentPlaceJB.vue";
import entertainmentPlaceKTV from "@/views/industryControl/entertainmentPlace/components/entertainmentPlaceKTV.vue";
import _ from "lodash";
export default defineComponent({
  name: "entertainmentPlace",
  components: {
    entertainmentPlaceJB,
    entertainmentPlaceKTV
  },
  props: {},
  setup(props) {
    const state = reactive({
      ListIndex: 0,
      componentIs: "entertainmentPlaceJB",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column"
      },
      list: [
        {
          name: "酒吧",
          is: "entertainmentPlaceJB"
        },
        {
          name: "KTV",
          is: "entertainmentPlaceKTV"
        }
      ]
    });
    const refData = toRefs(state);
    const ListClick = (item, index) => {
      state.ListIndex = index;
      state.componentIs = item.is;
    };
    return {
      ...refData,
      ListClick
    };
  }
});
</script>
<style lang="scss" scoped>
.entertainmentPlace {
  .tree-card {
    height: 100%;
    width: 300px;
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .hoverCard {
        // background: red;
        border: 1px solid #3a74fb;
        border-left: 5px solid #3a74fb;
        color: #3a74fb;
      }
      .el-card {
        margin: 10px 0 !important;
        :deep(.el-card__body) {
          display: flex !important;
          justify-content: space-around !important;
          cursor: pointer;
        }
        .mycard {
          display: flex !important;
          justify-content: space-between;
        }
      }
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
}
</style>
